import React from 'react'
import NavBarTwo from '../Components/NavBarTwo'

function PrivacyPolicy() {
  return (
    <div>
      <NavBarTwo />

      <div className="policy-container">
        <h1>Privacy Policy</h1>
        <p>Last updated: December 12th 2025</p>

        <h2>1. Introduction</h2>
        <p>
          Zindua App is a creator monetisation and influencer marketing platform. We value your privacy and are committed to protecting your personal data in compliance with the Kenya Data Protection Act, 2019.
          This Privacy Policy explains how we collect, use, store, and protect your information when you use our platform.
        </p>

        <h2>2. Data Controller and Data Processor</h2>
        <p>
          Zindua App acts as the Data Controller for personal data collected on the platform. We determine how and why your data is processed.
        </p>
        <p>
          We also work with trusted third party services, such as cloud hosting and payment providers, who act as Data Processors and only process data based on our instructions.
        </p>

        <h2>3. Information We Collect</h2>
        <p>We may collect the following information:</p>
        <ul>
          <li>Personal details such as name, email address, phone number, and profile photo</li>
          <li>Account login and authentication details</li>
          <li>Creator data including social media platforms, audience insights, pricing, and service packages</li>
          <li>Brand data including business details, campaign information, and preferences</li>
          <li>Payment related data processed securely by third party providers</li>
          <li>Technical data such as IP address, device type, browser, and usage activity</li>
        </ul>

        <h2>4. How We Use Your Information</h2>
        <p>Your data is used to:</p>
        <ul>
          <li>Create and manage your account</li>
          <li>Enable brands and creators to connect and work together</li>
          <li>Facilitate campaigns, subscriptions, and transactions</li>
          <li>Provide customer support and platform notifications</li>
          <li>Improve platform performance and user experience</li>
          <li>Comply with legal and regulatory obligations</li>
        </ul>

        <h2>5. Legal Basis for Processing</h2>
        <p>
          We process your personal data based on your consent, the need to perform a contract, compliance with legal obligations, and our legitimate interest in operating and improving the platform.
        </p>

        <h2>6. Firebase and Third Party Services</h2>
        <p>
          Zindua App uses Firebase services for authentication, database storage, file storage, and analytics.
          Firebase may collect and process certain technical and usage data on our behalf.
          All such processing is done in accordance with applicable data protection laws.
        </p>

        <h2>7. Data Sharing and Disclosure</h2>
        <p>
          We do not sell your personal data. Your information may only be shared:
        </p>
        <ul>
          <li>Between brands and creators where necessary to run campaigns or subscriptions</li>
          <li>With service providers such as payment processors and hosting platforms</li>
          <li>When required by law or regulatory authorities</li>
        </ul>

        <h2>8. Cookies and Tracking Technologies</h2>
        <p>
          We use cookies and similar technologies to remember preferences, improve functionality, and analyze platform usage.
          By using the platform, you consent to the use of cookies. You may manage or disable cookies through your browser settings.
        </p>

        <h2>9. Data Storage and Security</h2>
        <p>
          We implement appropriate security measures to protect your personal data from unauthorized access, loss, or misuse.
          Your data is stored securely and retained only for as long as necessary to fulfill the purposes outlined in this policy.
        </p>

        <h2>10. Your Rights</h2>
        <p>
          Under the Kenya Data Protection Act, you have the right to:
        </p>
        <ul>
          <li>Access your personal data</li>
          <li>Request correction of inaccurate or incomplete data</li>
          <li>Request deletion of your personal data</li>
          <li>Withdraw consent at any time</li>
          <li>Object to or restrict processing of your data</li>
        </ul>

        <h2>11. Third Party Links</h2>
        <p>
          The platform may contain links to third party websites or services. We are not responsible for their privacy practices or content.
        </p>

        <h2>12. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page, and continued use of the platform means you accept the updated policy.
        </p>

        <h2>13. Contact Us</h2>
        <p>
          If you have any questions, concerns, or requests regarding this Privacy Policy or your personal data, please contact us through our official support channels on the platform.
        </p>
      </div>
    </div>
  )
}

export default PrivacyPolicy